import React, { useEffect, useState } from "react";
import Header from "./components/header/Header";
import "./App.css";
import { message, auth } from "./components/service/firebase";
import Bottomnav from "./components/Bottomnav/Bottomnav";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import UserProfile from "./components/UserProfile/UserProfile";
import Menu from "./components/Menu/Menu";
import Home from "./components/Home/Home";

function App() {
  const [user, setUser] = useState(null);
  const [name, setName] = useState("");
  const [pic, setPic] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
        setName(authUser.displayName);
        setPic(authUser.photoURL);
      } else {
        // No user is signed in.
        setUser(null);
        setName("");
      }
    });
  }, [user]);

  useEffect(() => {
    message
      .requestPermission()
      .then(() => {
        return message.getToken();
      })
      .catch((error) => {
        console.log(error.message);
      });

    message.onMessage((payload) => {
      console.log("payload :", payload);
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route
            path="/userprofile"
            component={() => <UserProfile username={name} profilePic={pic} />}
          />
          <Route path="/menu" component={Menu} />
        </Switch>
        <div className="position-fixed fixed-bottom bg-primary p-2 bottomNav">
          <Bottomnav />
        </div>
      </div>
    </Router>
  );
}

export default App;
